import React, { lazy } from 'react';

const PurchaseTypeSubcontractorTypeMappingForm = lazy(() =>
  import(
    '../PurchaseTypeSubcontractorTypeMapping/PurchaseTypeSubcontractorTypeMappingForm'
  ).then(module => ({
    default: module.PurchaseTypeSubcontractorTypeMappingForm,
  })),
);

const purchaseTypeSubcontractorTypeMappingRoutes = [
  {
    props: {
      exact: true,
      path: '/:mode/general-settings/purchase-subcontractor-type-mapping',
    },
    component: <PurchaseTypeSubcontractorTypeMappingForm />,
  },
];

export default purchaseTypeSubcontractorTypeMappingRoutes;
